import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../../libs'
import { UserGroupEdit, UserGroupEditRequest } from './types'
import { $params } from '../../../../features/router'

export const submitEditGroup = createEvent<UserGroupEditRequest>()

export const setGroupEdit = createEvent<UserGroupEdit>()

export const groupMounted = createEvent()

export const closeModal = createEvent()

export const editGroup = fx<UserGroupEditRequest, void>({
  method: 'PUT',
  url: '/user_group/{groupId}',
})

export const getGroup = fx<void, UserGroupEdit>({
  method: 'GET',
  url: '/user_group/',
})

export const $group = restore(setGroupEdit, {
  name: '',
  role: {
    id: '',
  },
})

sample({
  clock: submitEditGroup,
  source: $params,
  fn: (params, user) => {
    let id

    if (params) {
      id = params.groupID
    }

    return {
      url: `/user_group/${id}`,
      body: { ...user },
    }
  },
  target: editGroup,
})

sample({
  clock: groupMounted,
  source: $params,
  fn: (params) => {
    let id
    if (params) {
      id = params.groupID
    }
    return {
      url: `/user_group/${id}`,
      query: {
        populate: JSON.stringify(['UserGroup.role']),
      },
    }
  },
  target: getGroup,
})

sample({
  clock: getGroup.doneData,
  fn: (doneData) => doneData.body,
  target: setGroupEdit,
})

export const $isSuccessCreate = restore(
  editGroup.doneData.map(() => true),
  false,
).reset(closeModal)
